<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="90px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="供应商编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.svCode">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="供应商名称" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.svName">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="供应商">
                <el-button v-authority="'BACK_MENU5_M3_B1'" class="btn-t-edit" @click="(add_or_edit = true), (editBoxShow = true)">新增</el-button>
                <el-button v-authority="'BACK_MENU5_M3_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total">
                <!-- <el-table-column prop="svId" label="序号" /> -->
                <el-table-column prop="svCode" label="供应商编号" />
                <el-table-column prop="svName" label="中文供应商名称" />
                <el-table-column prop="vendorName" label="供应商名称" />
                <el-table-column prop="svAddress" label="描述" />
                <el-table-column prop="updateTime" label="修改时间" />
                <el-table-column prop="updateTime" label="修改时间" />
                <el-table-column prop="palletFlag" label="托盘周转" >
                  <template slot-scope="scope">
                    <span v-if="scope.row.palletFlag == true">是</span>
                    <span v-if="scope.row.palletFlag == false">否</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU5_M3_B2'" size="mini" type="primary" @click="
                (add_or_edit = false),
                  (editBoxShow = true),
                  (mainObj = JSON.parse(JSON.stringify(scope.row)))
              " plain icon="el-icon-edit-outline" />
                        <el-button v-authority="'BACK_MENU5_M3_B3'" type="danger" @click="deleteRow(scope.row.svId)" size="mini" plain icon="el-icon-delete" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 新增&&编辑框 -->
        <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" :model="mainObj" @open="open" :style="$popups.popups(0.5,0.4)"  class="fromDialog">
            <span class="formClass">
                <el-form label-width="100px" :model="mainObj" :rules="rules" ref="mainObj">
                    <el-col :lg="11" :xl="11">
                        <el-form-item label="供应商编号" prop="svCode" class="EL-Form-Item">
                            <el-input v-model.trim="mainObj.svCode"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="11" :xl="11" :offset="1">
                        <el-form-item label="中文名称" prop="svName" class="EL-Form-Item">
                            <el-input v-model.trim="mainObj.svName"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="9" :xl="15" :offset="1">
                        <el-form-item label="托盘周转" prop="palletFlag" class="EL-Form-Item">
                          <el-select  collapse-tags v-model="mainObj.palletFlag" clearable="clearable">
                            <el-option value="false" label="否"></el-option>
                            <el-option  value="true" label="是"></el-option>
                          </el-select>

                        </el-form-item>
                    </el-col>
                    <el-col :lg="24" :xl="24">
                        <el-form-item label="描述" prop="svAddress">
                            <el-input type="textarea" v-model="mainObj.svAddress"> </el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button size="small" type="info" @click="editBoxShow = false">取 消</el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">新 增</el-button>
                <el-button size="small" type="primary" v-else @click="editRow">修 改</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "StockCheckTaskDetail",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                rules: {
                    svName: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    svCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                },
                showRoleBox: true,
                add_or_edit: Boolean, //新增|编辑
                loading: 0, //加载中
                editBoxShow: false, //编辑框
                dialogFormVisible: false,
                formLabelWidth: "140px", // 对话框大小
                tableHeight: 0, //表格高度
                testValue: 1,
                mainObj: {},
                pagination: {
                    pageSize: 50,
                    pageNum: 1,
                    svName: "",
                    svCode: "",
                    svAddres: "",

                },
				tableTotal:0,
                mainData: [],

                downloadLoading: false, //下载中

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    },1000)
                },
                deep: true,
            },
        },
        methods: {
            //获取数据
            getAuxiMaterialData() {
                this.$http
                    .request({
                        url: "/api/vendor/getVendorAll",
                        method: "GET",
                        params: this.pagination,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            //表单验证
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },
            //框打开
            open() {
                if (this.add_or_edit) {
                    //新增
                    this.mainObj = JSON.parse(JSON.stringify({}));
                } else {
                    this.getAuxiMaterialData();
                }
            },
            //新增
            add() {
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/vendor/insertVendor",
                            method: "POST",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "新增成功！",
                                    type: "success",
                                });
                                this.logRemarks = "vendor：供应商新增成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: "新增失败",
                                });
                                this.logRemarks = "vendor：供应商新增失败";
                            }
                            this.logContent = "svCode：" + this.mainObj.svCode;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //编辑
            editRow() {
                if (this.submitForm("mainObj")) {
                    this.$http
                        .request({
                            url: "/api/vendor/updateVendor",
                            method: "POST",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "修改成功！",
                                    type: "success",
                                });
                                this.logRemarks = "vendor：供应商修改成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "vendor：供应商修改失败";
                            }
                            this.logContent = "svCode：" + this.mainObj.svCode;
                            this.systemLog();
                            this.editBoxShow = false;
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //删除
            deleteRow(svId) {
                this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                        confirmButtonText: "删除",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/vendor/deleteVendor",
                                method: "DELETE",
                                showLoading: true,
                                params: {
                                    svId: svId,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "删除成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "vendor：供应商删除成功";
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: "删除失败",
                                    });
                                    this.logRemarks = "vendor：供应商删除失败";
                                }
                                this.logContent = "svId：" + svId;
                                this.systemLog();
                                this.getAuxiMaterialData();
                            })
                            .catch((error) => {
                                this.$notify.error({
                                    title: "失败",
                                    message: "调用失败",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },
            //重置
            resetData() {
                this.pagination = {
                    pageSize: 50,
                    pageNum: 1,
                    svName: "",
                    svCode: "",
                    svAddres: "",
                };
				this.tableTotal=0;
                this.getAuxiMaterialData();
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    svName: this.pagination.svName,
                    svCode: this.pagination.svCode,
                    svAddres: this.pagination.svAddres,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/vendor/getVendorAll',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                      list.forEach(function(c) {
                        if (c.palletFlag) {
                          c['palletFlag'] = '是'
                        } else if (c.palletFlag == false) {
                          c['palletFlag'] = '否'
                        }
                      });
                    const tHeader = ['供应商编号', '供应商名称', '描述', '修改时间', '创建时间','托盘周转']
                    const filterVal = ['svCode', 'svName', 'svAddress', 'updateTime', 'createTime','palletFlag']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '供应商数据'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "sys_vendor：导出供应商数据"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "供应商主数据",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
        },
    };
</script>

<style scoped>
</style>